export default "__VITE_ASSET__CrOwG3RX__"